let featureSwiper;

function initSwiper() {
    if (window.innerWidth < 1024) {
        if (!featureSwiper) {
            featureSwiper = new Swiper(".featureSwiper", {
                slidesPerView: 1.1,
                spaceBetween: 12,
                loop: true,

                pagination: {
                    el: ".swiper-pagination",
                    clickable: true
                },

                breakpoints: {
                    576: {
                        slidesPerView: 2,
                        spaceBetween: 12
                    }
                }
            });
        }
    } else {
        if (featureSwiper) {
            featureSwiper.destroy(true, true);
            featureSwiper = undefined;
        }
    }
}

document.addEventListener("DOMContentLoaded", initSwiper);
window.addEventListener("resize", initSwiper);